/* eslint-disable multiline-ternary */
import React from 'react';
import PageHeader from '../common/PageHeader';
import { marketColumns, marketConfig } from '../../constants/MockData';
import GridTable from '../common/Table/Table';
import './style.less';
import { apiRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import { Tooltip, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import { withRouter } from 'react-router-dom';
import { routes } from '../../constants/routes';
import { ShowToast, toastType } from '../../utils/toast-service';
import commonLabels from '../../constants/messageConstants';
import PropTypes from 'prop-types';
import { UpdateColumnWithConfiguration } from '../../utils/helper';
import MarketInfo from './MarketInfo';
import _ from 'lodash';
import { getFormattedValues } from '../../utils/formatData';

class Market extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      marketdata: [],
      configuration: undefined,
      detailView: false,
      selectedMarketID: undefined
      // employeeData: [],
      // propertyData: []
    };
  }

  componentDidMount () {
    this._asyncRequest = apiRequest({
      url: API_URL.Market.marketdata
    })
      .then((externalData) => {
        this._asyncRequest = null;
        if (externalData.success === true) {
          function compare (a, b) {
            if (a.parentMarketId < b.parentMarketId) {
              return -1;
            }
            if (a.parentMarketId > b.parentMarketId) {
              return 1;
            }
            return 0;
          }
          console.log(externalData.data);
          externalData.data.sort(compare);
          console.log(externalData.data);
          this.setState({
            marketdata: externalData.data || [],
            configuration: externalData.config || []
          });
        } else {
          ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
        }
      })
      .catch((reason) => {
        this._asyncRequest = null;
        ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
      });
  }

  componentWillUnmount () {
    if (this._asyncRequest) {
      // this._asyncRequest.cancel();
    }
  }

  static getDerivedStateFromProps (newProps, state) {
    if ((((newProps || {}).location || {}).navProps || {}).reload !== (state || {}).reload) {
      // this.LoadData();
      return {
        p: '',
        reload: (((newProps || {}).location || {}).navProps || {}).reload,
        detailView: false,
        selectedMarketID: undefined
      };
    }
  }

  renderActionColumn = (cellInfo, key) => {
    switch (key) {
      case 'viewEmployee':
        return (
          <>
            {/* <Tooltip title="View Employees"> */}
            <IconButton
              disabled="true"
              aria-label={'refreshData'}
              size="small"
              style={{ paddingLeft: '187px' }}
            >
              {/* <Visibility fontSize="small" size="small" /> */}
              <span style={{ color: '#002f6c', fontSize: '0.800rem' }}
              // onClick={() => {
              //  this.props.history.push(`${routes.employee}?market=${cellInfo.marketId}&type=${cellInfo.sourceType}&id=${cellInfo.typeId}`);
              // }}
              >{getFormattedValues(cellInfo.employeeCount, 'Number')}</span>
            </IconButton>
            {/* </Tooltip> */}
          </>
        );
      case 'viewProperty':
        return (
          <>
            {/* <Tooltip title="View Properties"> */}
            <IconButton
              disabled="true"
              aria-label={'View Properties'}
              size="small"
              style={{ paddingLeft: '11px' }}
            // onClick={() => {
            //   this.props.history.push(`${routes.property}?market=${cellInfo.marketId}&type=${cellInfo.sourceType}&id=${cellInfo.typeId}`);
            // }}
            >
              <span className="right-text"
                style={{ paddingRight: '0px !important', color: '#002f6c', fontSize: '0.800rem' }}>{cellInfo.propertyCount}</span>
            </IconButton>
            {/* </Tooltip> */}
          </>
        );
      case 'viewOtherEmployee':
        return (
          <>
            {/* <Tooltip title="View Other Employee"> */}
            <IconButton
              disabled="true"
              // aria-label={'View Properties'}
              size="small"
              style={{ paddingLeft: '187px' }}
            // onClick={() => {
            //   this.props.history.push(`${routes.property}?market=${cellInfo.marketId}&type=${cellInfo.sourceType}&id=${cellInfo.typeId}`);
            // }}
            >
              {/* <Visibility fontSize="small" size="small" /> */}
              <span className="right-text"
                style={{ paddingRight: '0px !important', color: '#002f6c', fontSize: '0.800rem' }}>{cellInfo.otherEmployeeCount}</span>
            </IconButton>
            {/* </Tooltip> */}
          </>
        );
      default:
        break;
    }
  };

  onRowClick = (data) => {
    this.setState({ detailView: true, selectedMarketID: data.marketId });
  };

  onBackClick = () => {
    this.setState({ detailView: false, selectedMarketID: undefined });
  };

  render () {
    const { marketdata, configuration, detailView } = this.state;
    return (
      <>
        {detailView && this.state.selectedMarketID ? (
          <>
            <MarketInfo selectedMarketID={this.state.selectedMarketID} onBackClick={this.onBackClick} />
          </>
        ) : (
          <>
            <PageHeader title="Markets"></PageHeader>
            <div className="row table-list-container">
              <GridTable
                columns={UpdateColumnWithConfiguration(marketColumns, configuration)}
                data={_.orderBy(marketdata, ['parentMarketId'], ['asc'])}
                config={marketConfig}
                renderActionColumn={this.renderActionColumn}
                onRowClick={this.onRowClick}
              ></GridTable>
            </div>
          </>
        )}
      </>
    );
  }
}

Market.propTypes = {
  history: PropTypes.any
};
export default withRouter(Market);
